// Back-compat shim. The unified store now lives in useSidebarBadges.js
// (claims + pending PL rows + composite Inbox total) so the sidebar can
// show all badges from one source. Old callers that imported
// useChatClaimsBadge / useChatClaimsBadgePoller still work — they map
// onto the new store transparently.
//
// New code should import from `@/composables/useSidebarBadges` directly.

import { useSidebarBadges, useSidebarBadgesPoller, invalidateSidebarBadge } from './useSidebarBadges'

export function useChatClaimsBadge() {
  const { claimsCount, loaded } = useSidebarBadges()

  return {
    count: claimsCount,
    loaded,
    refresh: () => invalidateSidebarBadge('claims'),
  }
}

export function useChatClaimsBadgePoller() {
  return useSidebarBadgesPoller()
}
